import { EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type SourcingCandidateEvents =
  | 'JOB_POSTING_PAGE_CLICK_CANDIDATE_TAB'
  | 'JOB_POSTING_PAGE_CLICK_CANDIDATE_NAME'
  | 'JOB_POSTING_PAGE_CLICK_CANDIDATE_SUPPLIER'
  | 'CANDIDATE_CARD_CLICK_CLOSE_BUTTON'
  | 'CANDIDATE_CARD_CLICK_VIEW_DETAILS_BUTTON'
  | 'CANDIDATE_CARD_CLICK_ENGAGEMENT_HISTORY_EXPANSION_PANEL_BUTTON'
  | 'CANDIDATE_CARD_CLICK_DOCUMENTS_DOWNLOAD_RESUME'
  | 'CANDIDATE_CARD_CLICK_CANDIDATE_APPROVE_BUTTON'
  | 'CANDIDATE_CARD_CLICK_CANDIDATE_REJECT_BUTTON'
  | 'CANDIDATE_CARD_CLICK_MOVE_STAGE_BUTTON'
  | 'JOB_POSTING_CANDIDATE_RESUME_DOWNLOAD';

export const sourcingCandidate: Record<SourcingCandidateEvents, MixpanelEvent> = {
  JOB_POSTING_CANDIDATE_RESUME_DOWNLOAD: {
    eventDescription: 'Job posting candidate resume download',
    eventKey: 'job-posting-candidate-resume-download',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  JOB_POSTING_PAGE_CLICK_CANDIDATE_TAB: {
    eventDescription: 'Job Posting Page User clicks Candidate tab',
    eventKey: 'job-posting-page-user-click-candidate-tab',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  JOB_POSTING_PAGE_CLICK_CANDIDATE_NAME: {
    eventDescription: 'Job Posting Page User clicks candidate name in candidate tab',
    eventKey: 'job-posting-page-user-click-candidate-name-on-candidate-tab',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  JOB_POSTING_PAGE_CLICK_CANDIDATE_SUPPLIER: {
    eventDescription: 'Job Posting Page User clicks candidate supplier in candidate tab',
    eventKey: 'job-posting-page-user-click-candidate-supplier-on-candidate-tab',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CANDIDATE_CARD_CLICK_CLOSE_BUTTON: {
    eventDescription: 'Candidate card User clicks close button',
    eventKey: 'candidate-card-user-click-close-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CANDIDATE_CARD_CLICK_VIEW_DETAILS_BUTTON: {
    eventDescription: 'Candidate card User clicks view details button',
    eventKey: 'candidate-card-user-click-view-details-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CANDIDATE_CARD_CLICK_ENGAGEMENT_HISTORY_EXPANSION_PANEL_BUTTON: {
    eventDescription: 'Candidate card User clicks engagement history expansion panel button',
    eventKey: 'candidate-card-user-click-highlights-interview-expansion-panel-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CANDIDATE_CARD_CLICK_DOCUMENTS_DOWNLOAD_RESUME: {
    eventDescription: 'Candidate card User clicks document resume download',
    eventKey: 'candidate-card-user-click-documents-resume-download',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CANDIDATE_CARD_CLICK_CANDIDATE_APPROVE_BUTTON: {
    eventDescription: 'Candidate card User clicks candidate approve button',
    eventKey: 'candidate-card-user-click-candidate-approve-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CANDIDATE_CARD_CLICK_CANDIDATE_REJECT_BUTTON: {
    eventDescription: 'Candidate card User clicks candidate reject button',
    eventKey: 'candidate-card-user-click-candidate-reject-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CANDIDATE_CARD_CLICK_MOVE_STAGE_BUTTON: {
    eventDescription: 'Candidate card User clicks move stage button',
    eventKey: 'candidate-card-user-click-move-stage-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  }
} as const;
